<template>
  <main class="relative">
    <!-- Hero section -->
    <cms-section
      v-if="eSpots?.[0]?.items"
      v-style:p="{ sm: '0 0 8vw', md: '0' }"
      :section="eSpots[0]"
    />
    <section v-else class="c-white flex center relative">
      <base-picture v-bind="hero.image" class="w-full" />
      <div class="text-center absolute">
        <base-picture v-style:w="{ sm: '30.6vw', lg: '12.5vw' }" v-bind="hero.logo" class="mb-4" />
        <h1
          v-style:text-size="{ sm: '8vw', lg: '3vw' }"
          v-html="hero.heading"
          class="fw-medium leading-none mb-5 text-center"
        />
        <p
          v-style:m="{ sm: '0 0 5.33vw 0', lg: '0 0 2vw 0' }"
          v-html="hero.paragraph"
          class="text-center"
        />
        <div class="mx-a f-col gap-3 w-max">
          <vf-button
            v-if="!auth.loggedIn"
            @click="DialogSignUp.open({
              formLocation: 'modal:single:body:none',
            })"
          >
            {{ hero.signUpCta }}
          </vf-button>
          <vf-button
            :to="auth.loggedIn ? '/account/loyalty' : ''"
            variant="primary-inverse"
            @click="!auth.loggedIn && DialogSignIn.open({
              formLocation: 'modal:single:body:none',
            })"
          >
            {{ auth.loggedIn ? hero.myAccountCta : hero.accessAccountCta }}
          </vf-button>
        </div>
      </div>
      <custom-arrow-scroll class="mb-15 mr-10 bottom-0 right-0 absolute <lg:hidden" to="#benefits" />
    </section>
    <!-- benefits section -->
    <section
      v-intersection-observer="([{ isIntersecting }]) => isIntersecting ? activeSection = 'benefits' : ''"
      v-style:p="{ sm: '10.66vw 8vw', lg: '5.55vw' }"
      id="benefits"
      class="c-white bg-brand-1 relative"
    >
      <div
        v-style:p="{ sm: '14vw 0 2.60vw 2.60vw ', lg: '2.60vw 0' }"
        class="c-black flex h-full items-end bottom-0 right-0 absolute"
      >
        <div
          class="rounded-l-md bg-white center sticky z-2 <lg:mr-1 <lg:rounded-full"
          style="bottom: 7.81rem; max-height: 20rem"
          @mouseenter="showMembershipContent = true"
          @mouseleave="showMembershipContent = false"
        >
          <base-button class="hidden <lg:block" style="padding: 4vw" @click="membershipCardModal = true">
            <base-picture v-bind="benefits.membershipIcon" style="height:  6.66vw; width: 6.66vw" />
          </base-button>
          <div
            v-if="!showMembershipContent"
            class="lh-none underlined uppercase rotate-180 write-vertical-left <lg:hidden"
            style="font-size: .83vw; padding: 1.04vw; top: 5.20vh"
          >
            {{ benefits.membershipCard }}
          </div>
          <div v-else class="p-5 text-center f-col center space-y-3 <lg:hidden" style="width: 23vw">
            <h3 class="fw-medium" style="font-size: 1.14vw">
              {{ benefits.membershipCardTitle }}
            </h3>
            <p style="font-size: .83vw">
              {{ benefits.membershipCardDescription1 }}
            </p>
            <p style="font-size: .83vw">
              {{ benefits.membershipCardDescription2 }}
            </p>
            <vf-button v-if="!auth.loggedIn" to="/sign-in">
              {{ hero.signUpCta }}
            </vf-button>
            <vf-link :to="auth.loggedIn ? '/account/loyalty' : '/sign-in'">
              {{ auth.loggedIn ? hero.myAccountCta : hero.accessAccountCta }}
            </vf-link>
          </div>
        </div>
      </div>
      <div class="text-center">
        <base-picture
          v-bind="hero.logo"
          class="mx-a <lg:hidden"
          style="margin-bottom: 3.57vw; width: 8.33vw"
        />
        <h2
          v-style="{
            'p': { sm: '0 0 8vw 0', lg: '0 0 3.47vw 0' },
            'text-size': { sm: '5.86vw', lg: '1.52vw' },
          }"
          v-html="benefits.heading"
        />
        <base-grid class="relative" :cols="{ sm: 2, lg: 4 }" :gap="{ sm: 'xs', md: 'sm' }">
          <div
            v-for="({ title, description, image }, key) in benefits.items"
            :key
            v-style:p="{ sm: '5.33vw', lg: '4.16vw 0.63rem' }"
            class="b b-white rounded-lg f-col center relative"
            tabindex="0"
            @blur="benefitsActiveItem = -1"
            @click="benefitsActiveItem = key"
            @focus="benefitsActiveItem = key"
          >
            <base-picture
              v-style="{
                mb: { sm: '2.66vw', lg: '1.38vw' },
                w: { sm: '10.66vw', lg: '3.47vw' },
              }"
              v-bind="image"
              class="relative z-0"
            />
            <p v-style:text-size="{ sm: '3.73vw', lg: '1.11vw' }">
              {{ title }}
            </p>

            <div
              v-style="{
                w: {
                  sm: benefitsActiveItem === key && 'calc(200% + 0.625rem)',
                  md: benefitsActiveItem === key && 'calc(200% + 1.2rem)',
                  lg: '100%',
                },
                h: { sm: '102%', lg: '100%' },
                p: { sm: '0 8vw', lg: '1.25rem' },
              }"
              class="rounded-lg bg-brand-1 flex center absolute z-1 duration <lg:c-black <lg:bg-white lg:hover:op-100"
              :class="[
                benefitsActiveItem === key ? 'op-100' : 'w-0 op-0',
                key % 2 === 0 ? 'left-0' : 'right-0',
              ]"
            >
              <base-button
                aria-controls="close"
                class="m-2 right-0 top-0 absolute lg:hidden"
                @click.stop="benefitsActiveItem = -1"
              >
                <vf-icon name="close" size="md" />
              </base-button>
              <p>{{ description }}</p>
            </div>
          </div>
        </base-grid>
      </div>
    </section>
    <cms-section
      v-if="eSpots?.[1]?.items"
      v-style:p="eSpots?.[1]?.items.length < 2 && { sm: '0 0 8vw', md: '0' }"
      :section="eSpots[1]"
    />
    <!-- basecamp section -->
    <section
      v-intersection-observer="([{ isIntersecting }]) => isIntersecting ? activeSection = 'basecamp' : ''"
      id="basecamp"
      class="lg:flex"
    >
      <div
        v-style:aspect-ratio="{ sm: '414/336', md: '390/400', lg: '1140/1168' }"
        class="h-full relative lg:w-1/2"
      >
        <div v-for="(image, key) in basecamp.carousel" :key class="full absolute">
          <base-picture v-bind="image" class="duration-500" :class="{ 'op-0': currentImage !== key }" />
        </div>
      </div>
      <div
        v-style="{
          p: { sm: '5.33vw', lg: '0' },
          w: { lg: '31.94vw' },
        }"
        class="f-col center relative lg:mx-a lg:items-start"
      >
        <h2 v-style:text-size="{ sm: '10.13vw', lg: '3.33vw' }" class="c-black lh-none">
          {{ basecamp.heading1 }}
        </h2>
        <h2
          v-style="{
            'mb': { sm: '5.33vw', lg: '2.08vw' },
            'text-size': { sm: '10.13vw', lg: '3.33vw' },
          }"
          class="c-black lh-none flex items-center"
        >
          <base-picture
            v-style:h="{ sm: '9.33vw', lg: '3.125vw' }"
            v-bind="basecamp.logo"
            class="mb-2 mr-2 w-a"
          />
          {{ basecamp.heading2 }}
        </h2>
        <p
          v-style="{
            'mb': { sm: '5.33vw', lg: '2.08vw' },
            'text-size': { sm: '4.26vw', lg: '1.25vw' },
          }"
          class="c-black fw-medium lh-none <lg:text-center"
        >
          {{ basecamp.paragraph1 }}
        </p>
        <p
          v-style="{
            'mb': { lg: '2.08vw' },
            'text-size': { lg: '1.25vw' },
          }"
          class="c-black lh-none text-center lg:text-left <lg:hidden"
        >
          {{ basecamp.paragraph2 }}
        </p>
        <vf-button class="text-base lh-tight my-1 mr-a px-15 py-3 w-full lg:w-a" :to="basecamp.ctaLink">
          {{ basecamp.cta }}
        </vf-button>
      </div>
    </section>
    <!-- community section -->
    <section
      v-intersection-observer="([{ isIntersecting }]) => isIntersecting ? activeSection = 'community' : ''"
      v-style:p="{ sm: '8vw 0', lg: '5.5vw 0' }"
      id="community"
      class="c-white bg-black flex flex-col-reverse lg:flex-row"
    >
      <div class="px-12 shrink-0 relative lg:px-0 lg:w-2/3">
        <base-grid class="gap-1" :cols="{ sm: 2, lg: 4 }">
          <base-link
            v-for="({ username, to, image, hideOnMobile }, key) in community.instagrams"
            :key
            class="block relative overflow-hidden"
            :class="{ '<md:hidden': hideOnMobile }"
            :to
          >
            <div
              class="p-1 flex w-full pointer-events-none items-center bottom-0 left-0 absolute z-1"
            >
              <vf-icon name="instagram" size="xl" />
              <span v-style:text-size="{ sm: '2.4vw', lg: '0.90vw' }" class="truncate">
                {{ username }}
              </span>
            </div>
            <base-picture v-bind="image" class="w-full duration hover:scale-105" />
          </base-link>
        </base-grid>
      </div>
      <div class="m-a px-10 <lg:text-center">
        <h2 v-style:text-size="{ sm: '6.4vw', lg: '2.22vw' }" class="mb-8">
          {{ community.heading }}
        </h2>
        <p v-style:text-size="{ sm: '4.26vw', lg: '1.25vw' }" style="margin-bottom: 8vw">
          <base-interpolator :content="community.paragraph">
            <template #instagram-link="{ args: [message] }">
              <base-link class="fw-medium" :to="community.tnfInstagram">
                {{ message }}
              </base-link>
            </template>
          </base-interpolator>
        </p>
      </div>
    </section>
    <div
      v-style:p="{ sm: '5.33vw 4vw', lg: '1.56vw 0' }"
      class="c-white bg-grey-10 w-full bottom-0 sticky z-3"
    >
      <ul
        v-style="{
          'max-w': { lg: '28rem' },
          'text-size': { sm: '2.93vw', lg: '.83vw' },
        }"
        class="mx-a flex between"
      >
        <li v-for="({ title, target }, key) in nav" :key>
          <base-link
            class="uppercase hover:underlined"
            :class="{ underlined: activeSection === target }"
            :to="`#${target}`"
          >
            {{ title }}
          </base-link>
        </li>
      </ul>
    </div>
    <transition appear :duration="250" name="nested">
      <vf-modal v-if="membershipCardModal" size="lg" @resolve="membershipCardModal = false">
        <div class="c-black text-center f-col center space-y-4" style="font-size: 4.26vw">
          <base-picture v-bind="hero.logo" class="mb-4" style="width: 26.66vw; filter: invert(100%)" />
          <h3 class="fw-medium">
            {{ benefits.membershipCardTitle }}
          </h3>
          <p>
            {{ benefits.membershipCardDescription1 }}
          </p>
          <p>
            {{ benefits.membershipCardDescription2 }}
          </p>
          <vf-button v-if="!auth.loggedIn" to="/sign-in">
            {{ hero.signUpCta }}
          </vf-button>
          <vf-link
            v-style:text-size="{ sm: '3.73vw', md: '1rem' }"
            class="text-base"
            :to="auth.loggedIn ? '/account' : '/sign-in'"
          >
            {{ auth.loggedIn ? hero.myAccountCta : hero.accessAccountCta }}
          </vf-link>
        </div>
      </vf-modal>
    </transition>
  </main>
</template>

<script lang="ts" setup>
import { vIntersectionObserver } from '@vueuse/components'

const { $locale } = useNuxtApp()
const { supportedLocales = [] } = useAppConfig().pages.loyaltyProgramme

if (!supportedLocales.includes($locale))
  throw createError({ message: `Page is not available for ${$locale} locale`, statusCode: 404, fatal: true })

definePageMeta({ header: { transparent: true } })

const auth = useAuthStore()
const { DialogSignUp, DialogSignIn } = useDialogsStore()

const eSpots = (await useCms().getSections.generic('loyalty-programme')).data.value?.content.sections
const { data, error } = await useApi().internal.getStaticPage('loyalty-programme/loyalty-programme')
if (!data.value) throw createError({ ...error.value!, fatal: true })
const { hero, benefits, basecamp, community, nav } = data.value

const { query } = useRoute()
const currentImage = ref(0)
const activeSection = ref()
const benefitsActiveItem = ref()
const showMembershipContent = ref(false)
const membershipCardModal = ref(false)

useIntervalFn(() => {
  currentImage.value = (currentImage.value + 1) % basecamp.carousel.length
}, 2000)

onMounted(() => {
  if (query.signup) DialogSignUp.open()
})
</script>
